'use client'

import * as React from 'react';
import { Button } from './Button';
import type { ButtonProps } from '../../types/ButtonProps';
import { ArrowRight } from 'lucide-react';
import Link from 'next/link';
import type { Session } from 'next-auth';
import { useClientSession } from '../../hooks';

/**
 * @group Components
 * @summary <blockquote>A button component that links to dashboard or signin based on session state.</blockquote>
 * @example
 * ```tsx
 * <GetStartedButton className="custom-class" />
 * ```
 */
export function GetStartedButton({ className, ...props }: Omit<ButtonProps, 'asChild' | 'size'> & { className?: string}) {
  const {session} = useClientSession();
  const href = session?.user ? '/dashboard' : '/users/signin';
  
  return (
    <Button 
      asChild 
      size="lg" 
      className={`text-lg bg-brand-secondary hover:bg-brand-secondary/90 ${className || ''}`}
      {...props}
    >
      <Link href={href} className="inline-flex items-center gap-2">
        Get Started
        <ArrowRight className="h-5 w-5" />
      </Link>
    </Button>
  )
} 